"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyInformationContent = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MyInformationContent = ({
  emailAddress,
  isEmailMissingMessageVisible,
  isPhoneMissingMessageVisible,
  phoneNumber,
  profileLink,
  shoppingBagOwnerName
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shoppingBagOwnerName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoItem, {
      variant: "body1",
      ...getTestIdProps(_models.TestId.MyInformationName),
      children: shoppingBagOwnerName
    }) : null, phoneNumber ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoItem, {
      variant: "body1",
      ...getTestIdProps(_models.TestId.MyInformationPhoneNumber),
      children: phoneNumber
    }) : null, emailAddress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoItem, {
      variant: "body1",
      ...getTestIdProps(_models.TestId.MyInformationEmailAddress),
      children: emailAddress
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ChangeMessage, {
      variant: "body1",
      ...getTestIdProps(_models.TestId.MyInformationChange),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "needToMakeAChange"
      }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: profileLink,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "goToYourProfileSettings"
        })
      })]
    }), isEmailMissingMessageVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MissingAlert, {
      severity: "error",
      variant: "standard",
      ...getTestIdProps(_models.TestId.MyInformationEmailAddressMissing),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "yourEmailAddressIsMissing"
      }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: profileLink,
        color: "inherit",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "goToYourProfileSettings"
        })
      })]
    }) : null, isPhoneMissingMessageVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MissingAlert, {
      severity: "error",
      variant: "standard",
      ...getTestIdProps(_models.TestId.MyInformationPhoneNumberMissing),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "yourPhoneNumberIsMissing"
      }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        href: profileLink,
        color: "inherit",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "goToYourProfileSettings"
        })
      })]
    }) : null]
  });
};
exports.MyInformationContent = MyInformationContent;